<div class="page-wrapper min-vh-100 bg-light">
  <InactivityModal />

  <div class="vh-100 d-flex flex-column bg-gray overflow-hidden">
    <Navbar
      @sidebar-toggle="toggleSidebar"
      class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0"
    >
    </Navbar>

    
  <Sidebar variant="mobile" offcanvas_id="dashboardSidebarOffcanvas" />
<div class="container-fluid flex-grow-1 overflow-hidden">
      <div class="row h-100">
        <div v-if="show_sidebar" class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
          <div class="mt-2">
            <Sidebar ref="sidebar" />
          </div>
        </div>

        <div class="col h-100 overflow-auto mt-2">
          <div class="bg-gray px-2 py-1 h-100 scrollable-container mb-5">
            <main
              v-if="loading"
              class="text-center py-5 w-100"
            >
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted text-xxs">Loading Incidents...</p>
            </main>

            <main v-else class="pb-extra">
              <div class="card bg-transparent mt-3 rounded border-0">
                <div class="card-body px-0">
                  <div class="dashboard-content-header d-flex align-items-center justify-content-between flex-wrap gap-2 mb-4">
                <div class="d-flex align-items-center gap-2">
                  <button
                    class="btn btn-light border rounded-circle d-inline-flex d-lg-none align-items-center justify-content-center p-0 dashboard-workspace-menu"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#dashboardSidebarOffcanvas"
                    aria-controls="dashboardSidebarOffcanvas"
                    aria-label="Open workspace menu"
                  >
                    <i class="bx bx-menu-alt-left fs-5"></i>
                  </button>
                  <div>
                    <p class="text-uppercase text-primary text-xxs fw-bold mb-1">Workspace</p>
                    <h5 class="fw-bold text-dark mb-0">Manage Incidents</h5>
                  </div>
                </div>
                <span class="fw-bold text-xs d-inline-flex align-items-center gap-1 text-primary">
                  <i class="bi bi-shield-exclamation"></i>
                  Incident control
                </span>
                  </div>

                  <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3 mb-4">
                    <div>
                      <p class="fs-xsm text-dark flex-grow-1 mb-0">Review, assign and track all logged cases.</p>
                      <div class="alert alert-primary d-flex align-items-start gap-2 mt-2 mb-0 px-3 py-2 text-xs" role="note">
                        <i class="bi bi-info-circle-fill flex-shrink-0" aria-hidden="true"></i>
                        <span>Admins within the system can be assigned to incidents to manage and resolve them.</span>
                      </div>
                    </div>
                  </div>

                  <div class="row g-3 mb-4">
                <div class="col-6 col-xl-3">
                  <div class="card h-100 incident-card-border shadow-sm rounded incident-summary-card">
                    <div class="card-body d-flex align-items-center justify-content-between gap-2 p-3 p-md-4">
                      <div>
                        <p class="small text-muted fw-semibold text-uppercase mb-1">Total cases</p>
                        <h3 class="fw-bold mb-1">{{ logged_entries.length }}</h3>
                        <span class="fs-xsm text-muted">Live incident reports</span>
                      </div>
                      <span class="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary-subtle text-primary marketplace-thumb-placeholder">
                        <i class="bi bi-folder2-open fs-4"></i>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-6 col-xl-3">
                  <div class="card h-100 incident-card-border shadow-sm rounded incident-summary-card">
                    <div class="card-body d-flex align-items-center justify-content-between gap-2 p-3 p-md-4">
                      <div>
                        <p class="small text-muted fw-semibold text-uppercase mb-1">Unassigned</p>
                        <h3 class="fw-bold mb-1">{{ unassigned_incidents }}</h3>
                        <span class="fs-xsm text-danger">Needs attention</span>
                      </div>
                      <span class="d-inline-flex align-items-center justify-content-center rounded-circle bg-danger-subtle text-danger marketplace-thumb-placeholder">
                        <i class="bi bi-person-exclamation fs-4"></i>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-6 col-xl-3">
                  <div class="card h-100 incident-card-border shadow-sm rounded incident-summary-card">
                    <div class="card-body d-flex align-items-center justify-content-between gap-2 p-3 p-md-4">
                      <div>
                        <p class="small text-muted fw-semibold text-uppercase mb-1">In progress</p>
                        <h3 class="fw-bold mb-1">{{ in_progress_incidents }}</h3>
                        <span class="fs-xsm text-muted">Currently being handled</span>
                      </div>
                      <span class="d-inline-flex align-items-center justify-content-center rounded-circle bg-warning-subtle text-warning marketplace-thumb-placeholder">
                        <i class="bi bi-hourglass-split fs-4"></i>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-6 col-xl-3">
                  <div class="card h-100 incident-card-border shadow-sm rounded incident-summary-card">
                    <div class="card-body d-flex align-items-center justify-content-between gap-2 p-3 p-md-4">
                      <div>
                        <p class="small text-muted fw-semibold text-uppercase mb-1">Resolved</p>
                        <h3 class="fw-bold mb-1">{{ resolved_incidents }}</h3>
                        <span class="fs-xsm text-success">{{ incident_resolution_rate }}% resolution rate</span>
                      </div>
                      <span class="d-inline-flex align-items-center justify-content-center rounded-circle bg-success-subtle text-success marketplace-thumb-placeholder">
                        <i class="bi bi-check2-circle fs-4"></i>
                      </span>
                    </div>
                  </div>
                </div>
                  </div>

                <div>
                  <div class="card incident-card-border shadow-sm rounded overflow-visible">
                    <div class="card-header bg-white border-0 d-flex flex-wrap align-items-center justify-content-between gap-2 p-4 position-relative rounded-top-4">
                      <div>
                        <h5 class="fw-bold mb-1">Logged cases</h5>
                      </div>
                      <button
                        ref="incidentFilterToggle"
                        type="button"
                        class="btn btn-light border rounded incident-filter-toggle position-relative"
                        :class="{ active: incident_filter_panel_open }"
                        aria-label="Filter incident reports"
                        :aria-expanded="incident_filter_panel_open"
                        @click="toggle_incident_filter_panel"
                      >
                        <i class="bi bi-funnel-fill"></i>
                        <span v-if="active_incident_filter_count" class="incident-filter-count position-absolute d-inline-flex align-items-center justify-content-center rounded bg-primary text-white fw-bold">{{ active_incident_filter_count }}</span>
                      </button>

                      <div v-if="incident_filter_panel_open" class="incident-filter-scrim position-fixed top-0 end-0 bottom-0 start-0 bg-transparent" @click="incident_filter_panel_open = false"></div>
                      <div v-if="incident_filter_panel_open" class="task-filter-dropdown incident-filter-panel incident-filter-panel-inline position-absolute bg-white shadow rounded-3 overflow-x-hidden overflow-y-auto">
                          <div class="d-flex align-items-start justify-content-between gap-3 p-4 border-bottom">
                            <div>
                              <h4 class="fw-bold text-dark text-sm mb-0">Filter Incidents</h4>
                              <p class="text-muted mb-0 text-xxs">Narrow cases by keyword, assignee, or status.</p>
                            </div>
                            <button type="button" class="btn btn-light rounded-circle" aria-label="Close filters" @click="incident_filter_panel_open = false">
                              <i class="bi bi-x-lg"></i>
                            </button>
                          </div>

                          <div class="p-4">
                            <div class="mb-4">
                              <p class="small fw-bold text-uppercase text-muted mb-2 text-xxs">Assigned to</p>
                              <div class="d-flex flex-wrap gap-2">
                                <button
                                  v-for="assignee in incident_filter_assignees"
                                  :key="assignee.name"
                                  type="button"
                                  class="task-filter-chip status-inactive"
                                  :class="{ active: incident_filters.assignee === assignee.name }"
                                  @click="set_incident_filter('assignee', assignee.name)"
                                >
                                  <span class="incident-filter-avatar d-inline-flex align-items-center justify-content-center rounded-circle fw-bold">{{ assignee.initials }}</span>{{ assignee.name }}
                                </button>
                              </div>
                            </div>

                            <div class="mb-4">
                              <p class="small fw-bold text-uppercase text-muted mb-1 text-xxs">Status</p>
                              <div class="d-flex flex-wrap gap-2">
                                <button
                                  v-for="status in incident_filter_statuses"
                                  :key="status.value"
                                  type="button"
                                  class="task-filter-chip incident-status-chip d-inline-flex align-items-center gap-2 rounded-pill fw-semibold lh-1"
                                  :class="[status.class_name, { active: incident_filters.status === status.value }]"
                                  @click="set_incident_filter('status', status.value)"
                                >
                                  <span class="incident-filter-status-dot d-inline-block rounded-circle"></span>{{ status.label }}
                                </button>
                              </div>
                            </div>

                            <div class="d-flex gap-2">
                              <button type="button" class="btn btn-primary text-xxs rounded cursor-pointer ms-auto" @click="reset_incident_filters">Reset</button>
                            </div>
                          </div>
                        </div>
                    </div>

                    <div class="table-responsive px-3 px-lg-4 pb-3 pb-lg-4">
                      <table id="manage-incidents-table" class="table align-middle table-striped table-borderless mb-0 w-100">
                        <thead class="btn-primary text-white">
                          <tr>
                            <th class="py-3 text-nowrap">Case Ref</th>
                            <th class="py-3 text-nowrap">Type</th>
                            <th class="py-3">Details</th>
                            <th class="py-3">Location</th>
                            <th class="py-3 text-nowrap">Reported</th>
                            <th class="py-3 text-nowrap">Assigned to</th>
                            <th class="py-3 text-center text-nowrap">Status</th>
                            <th class="px-4 py-3 text-center text-nowrap">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="report in logged_entries"
                            :key="report.id"
                            :data-incident-assignee="get_incident_assignee(report)"
                            :data-incident-status="(report.incident_status?.name || '').trim().toLowerCase()"
                          >
                            <td class="text-wrap">
                              <div class="small fw-semibold">{{ report.ref_number }}</div>
                            </td>
                            <td class="text-wrap text-xs">
                              <div class="d-flex align-items-center">
                                  {{ get_incident_type_name(report.incident_type) }}
                              </div>
                            </td>
                            <td class="text-wrap text-xs">
                              <div :title="report.description || 'Incident report'">
                                {{ truncate_text(report.description || 'Incident report', 60) }}
                                </div>
                              </td>
                            <td>
                              <div class="small text-muted">{{ report.location || 'Location not provided' }}</div>
                            </td>
                            <td class="text-wrap text-xs">
                              {{ report.user?.full_name || report.user?.email || 'Anonymous' }} {{ report.date_created }}
                            </td>
                            <td class="manage-incident-assignee-cell">
                              <select
                                class="form-select form-select-sm fw-semibold text-xxs rounded"
                                :value="get_incident_assignee(report)"
                                @change="handle_incident_admin_change(report, $event)"
                              >
                                <option value="Unassigned">Unassigned</option>
                                <option
                                  v-if="get_incident_assignee(report) !== 'Unassigned' && !has_admin_assignee(get_incident_assignee(report))"
                                  :value="get_incident_assignee(report)"
                                >
                                  {{ get_incident_assignee(report) }}
                                </option>
                                <option
                                  v-for="admin in admins"
                                  :key="admin.id"
                                  :value="get_admin_display_name(admin)"
                                >
                                  {{ get_admin_display_name(admin) }}
                                </option>
                              </select>
                            </td>
                            <td class="text-center text-xs">
                             
                                {{ normalize_incident_status(report.incident_status?.name) }}
                            </td>
                            <td class="px-4 text-center text-nowrap">
                              <button
                                v-if="report.user?.id"
                                type="button"
                                class="btn btn-sm bg-primary text-white rounded shadow me-1"
                                :aria-label="`View ${report.user.full_name || report.user.email}'s profile`"
                                :title="report.user.full_name || report.user.email"
                                @click="view_profile(report.user)"
                              >
                                profile
                              </button>
                              <button type="button" class="btn btn-sm bg-primary text-white rounded shadow" :aria-label="`View case ${report.ref_number}`" @click="open_incident_details(report)">
                                View
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Teleport to="body">
    <div
      v-if="selected_incident"
      class="modal fade show d-block incident-details-modal"
      tabindex="-1"
      role="dialog"
      aria-modal="true"
      aria-labelledby="incident-details-title"
      @click.self="close_incident_details"
    >
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content rounded shadow">
        <div class="modal-header bg-primary position-relative">
          <div class="pe-5">
            <p class="small text-white mb-0 opacity-75">
              {{ selected_incident.ref_number }} &middot; {{ get_incident_type_name(selected_incident.incident_type) }}
            </p>
          </div>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            aria-label="Close incident details"
            @click="close_incident_details"
          ></button>
        </div>

        <div class="modal-body modal-body-scroll p-3">
          <section class="mb-5">
            <p class="text-xxs fw-bold text-uppercase text-muted mb-1">Report overview</p>
            <p class="small fw-bold text-uppercase mb-4">Case progress</p>
            <div class="incident-stage-track d-flex align-items-start w-100">
              <div v-for="(stage, stage_index) in incident_stages" :key="stage.value">
                <button
                  type="button"
                  class="incident-stage-button d-flex flex-column align-items-center p-0 border-0 bg-transparent fw-bold"
                  :class="{ active: is_incident_stage_complete(stage_index) }"
                  :data-stage="stage.value"
                  :disabled="updating_incident_status || !can_select_incident_stage(stage.value)"
                  @click="set_incident_stage(stage.value)"
                >
                  <span class="incident-stage-dot d-inline-flex align-items-center justify-content-center rounded-circle">
                    <i class="bi" :class="is_incident_stage_complete(stage_index) ? 'bi-check-lg' : 'bi-circle'"></i>
                  </span>
                  <span class="incident-stage-label">{{ stage.label }}</span>
                </button>
                <span
                  v-if="stage_index < incident_stages.length - 1"
                  class="incident-stage-line flex-grow-1 rounded"
                  :class="{ active: is_incident_stage_complete(stage_index + 1) }"
                  :data-stage="incident_stages[stage_index + 1].value"
                ></span>
              </div>
            </div>
          </section>

          <div class="mb-4">
            <p class="small fw-bold text-uppercase text-muted mb-2">Description</p>
            <p class="small lh-base mb-0">{{ selected_incident.description || 'No description provided.' }}</p>
          </div>

          <div class="mb-4">
            <p class="small fw-bold text-uppercase text-muted mb-2">Location</p>
            <p class="small mb-0">
              <i class="bi bi-geo-alt text-primary me-2"></i>{{ selected_incident.location || 'Location not provided' }}
            </p>
          </div>

          <div class="row g-4 mb-4">
            <div class="col-12 col-md-6">
              <p class="small fw-bold text-uppercase text-muted mb-2">Reported</p>
              <p class="small mb-0">{{ selected_incident.date_created }}</p>
            </div>
            <div class="col-12 col-md-6">
              <p class="small fw-bold text-uppercase text-muted mb-2">Reported by</p>
              <button
                v-if="selected_incident.user?.id"
                type="button"
                class="incident-reporter-button incident-reporter-button-modal d-inline-flex align-items-center justify-content-between gap-3 w-100 fw-bold text-start"
                :aria-label="`View ${selected_incident.user.full_name || selected_incident.user.email}'s profile`"
                :title="selected_incident.user.full_name || selected_incident.user.email"
                @click="view_profile(selected_incident.user)"
              >
                <span>{{ selected_incident.user.full_name || selected_incident.user.email }}</span>
                <i class="bi bi-chevron-right flex-shrink-0" aria-hidden="true"></i>
              </button>
              <p v-else class="fs-5 mb-0">Anonymous</p>
            </div>
            <div class="col-12 col-md-6">
              <label for="incident-assignee" class="form-label small fw-bold text-uppercase text-muted">Assigned to</label>
              <div class="input-group rounded">
                <span class="input-group-text bg-white text-primary"><i class="bi bi-person-plus"></i></span>
                <select
                  id="incident-assignee"
                  v-model="selected_incident_assignee"
                  class="form-select border-start-0 text-xxs"
                  @change="handle_incident_admin_change(selected_incident, $event)"
                >
                  <option value="Unassigned">Unassigned</option>
                  <option
                    v-if="get_incident_assignee(selected_incident) !== 'Unassigned' && !has_admin_assignee(get_incident_assignee(selected_incident))"
                    :value="get_incident_assignee(selected_incident)"
                  >
                    {{ get_incident_assignee(selected_incident) }}
                  </option>
                  <option
                    v-for="admin in admins"
                    :key="admin.id"
                    :value="get_admin_display_name(admin)"
                  >
                    {{ get_admin_display_name(admin) }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-12">
              <section class="incident-trail mt-2" aria-labelledby="manage-incident-tracking-title">
                <p id="manage-incident-tracking-title" class="small fw-bold text-muted mb-3">
                  Incident Tracking
                </p>
                <div v-if="get_incident_progress_history(selected_incident).length" class="incident-trail-body">
                  <div class="incident-trail-line"></div>
                  <div
                    v-for="progress in get_incident_progress_history(selected_incident)"
                    :key="progress.id"
                    class="incident-trail-item is-done d-flex align-items-start"
                    :data-step="progress.status?.name"
                    :data-action="progress.action_type"
                  >
                    <span class="incident-trail-icon" aria-hidden="true"></span>
                    <div class="incident-trail-content">
                      <p class="incident-trail-label mb-0">
                        {{ get_incident_progress_title(progress) }}
                      </p>
                      <p class="incident-trail-time mb-0">
                        {{ format_incident_progress_date(progress.created_at) }}
                        &middot; {{ get_incident_progress_actor(progress) }}
                      </p>
                      <p v-if="progress.note" class="small fst-italic mt-1 mb-0">
                        {{ progress.note }}
                      </p>
                    </div>
                  </div>
                </div>
                <p v-else class="small text-muted mb-0">No stored progress history is available.</p>
              </section>
            </div>
            <div class="col-12">
              <p class="small fw-bold text-uppercase text-muted mb-2">Attachments</p>
              <div v-if="get_attachment_count(selected_incident)" class="incident-feed-attachments">
                <div
                  v-for="(attachment, attachment_index) in get_visible_incident_images(selected_incident)"
                  :key="`${attachment.name}-${attachment.url}`"
                >
                  <button
                    type="button"
                    class="incident-feed-attachment incident-feed-attachment-image"
                    @click.stop="open_incident_image_modal(attachment, selected_incident)"
                  >
                    <img
                      :src="attachment.url"
                      :alt="attachment.name"
                      class="incident-feed-attachment-preview"
                      loading="lazy"
                    >
                    <span
                      v-if="attachment_index === 3 && get_incident_extra_image_count(selected_incident)"
                      class="incident-feed-attachment-more"
                    >
                      +{{ get_incident_extra_image_count(selected_incident) }}
                    </span>
                  </button>
                </div>
                <div
                  v-for="attachment in get_incident_file_attachments(selected_incident)"
                  :key="`${attachment.name}-${attachment.url}`"
                >
                  <a
                    class="incident-feed-attachment"
                    :class="{ 'is-disabled': !attachment.url }"
                    :href="attachment.url || undefined"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i class="bi" :class="attachment.icon"></i>
                    <span class="text-truncate">{{ attachment.name }}</span>
                  </a>
                </div>
              </div>
              <p v-else class="fs-5 text-muted mb-0"><i class="bi bi-paperclip me-1"></i>0</p>
            </div>
          </div>


        </div>

        <div class="px-3 pt-2 bg-white">
          <label for="incident-progress-note" class="form-label text-xxs fw-bold">
            Progress note <span class="fw-bold text-muted">(optional)</span>
          </label>
          <textarea
            id="incident-progress-note"
            v-model.trim="incident_progress_note"
            class="form-control text-xs"
            rows="2"
            maxlength="2000"
            placeholder="Add an update about the work completed"
          ></textarea>
        </div>

        <div class="modal-footer border-0 bg-white gap-2">
          <button
            v-if="selected_incident.incident_status?.name === 'assigned'"
            type="button"
            class="btn btn-primary rounded shadow-sm text-xxs"
            :disabled="updating_incident_status"
            @click="start_selected_incident"
          >
            {{ updating_incident_status ? 'Updating...' : 'Start progress' }}
          </button>
          <button
            v-else-if="selected_incident.incident_status?.name === 'in_progress'"
            type="button"
            class="btn btn-primary rounded shadow-sm text-xxs"
            :disabled="updating_incident_status"
            @click="resolve_selected_incident"
          >
            {{ updating_incident_status ? 'Updating...' : 'Mark as resolved' }}
          </button>
          <button
            v-else
            type="button"
            class="btn btn-light rounded"
            disabled
          >
            {{ selected_incident.incident_status?.name === 'resolved' ? 'Resolved' : 'Assign an admin to continue' }}
          </button>
        </div>
      </div>
    </div>
    </div>
    <div v-if="selected_incident" class="modal-backdrop fade show"></div>
  </Teleport>

  <Teleport to="body">
    <div class="modal fade incident-image-preview-modal manage-incident-image-preview-modal" id="manageIncidentImagePreviewModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content rounded shadow">
          <div class="modal-header bg-primary text-white position-relative">
            <p class="modal-title text-xxs fw-500 mb-0">
              {{ selected_incident_image?.name || 'Incident attachment' }}
            </p>
            <button
              type="button"
              class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
              aria-label="Close"
              @click="close_incident_image_modal"
            ></button>
          </div>
          <div class="modal-body p-3">
            <div class="incident-image-preview-shell">
              <button
                v-if="selected_incident_images.length > 1"
                type="button"
                class="incident-image-preview-nav incident-image-preview-nav-prev"
                aria-label="Previous image"
                @click="show_previous_incident_image"
              >
                <i class="bi bi-chevron-left"></i>
              </button>
              <img
                v-if="selected_incident_image"
                :src="selected_incident_image.url"
                :alt="selected_incident_image.name"
                class="incident-image-preview-img"
              >
              <button
                v-if="selected_incident_images.length > 1"
                type="button"
                class="incident-image-preview-nav incident-image-preview-nav-next"
                aria-label="Next image"
                @click="show_next_incident_image"
              >
                <i class="bi bi-chevron-right"></i>
              </button>
            </div>
            <div
              v-if="selected_incident_images.length > 1"
              class="incident-image-preview-counter text-center text-muted text-xxs mt-2"
            >
              {{ selected_incident_image_index + 1 }} of {{ selected_incident_images.length }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</div>
